// 🧩 Champs entreprise INDISPENSABLES — SOURCE UNIQUE.
// Utilisé par : la timeline (ProgressRoadmap), le calcul « profil complet »
// (advice.signals) et l'ancien encart ProfileSpotlight. Une seule définition
// pour qu'il n'y ait JAMAIS « profil ✓ » alors qu'il manque des infos.
export const PROFILE_ESSENTIALS = [
  { key: 'brand_primary',      icon: '🎨', label: 'Couleurs de marque', why: 'Tes campagnes et tes visuels prennent automatiquement TES couleurs, pas celles de tout le monde.' },
  { key: 'logo_url',           icon: '🖼️', label: 'Logo',              why: 'Il signe tes e-mails et tes visuels — tes clients te reconnaissent au premier coup d\'œil.' },
  { key: 'sector',             icon: '🏷️', label: 'Secteur d\'activité', why: 'Les conseils et les gains en CHF sont calculés pour TON métier, pas des moyennes génériques.' },
  { key: 'avg_client_value',   icon: '💰', label: 'Panier moyen',      why: 'C\'est ce qui permet de te dire combien chaque campagne peut te rapporter, en francs.' },
  { key: 'website',            icon: '🌐', label: 'Site web',          why: 'On y récupère tes couleurs en 1 clic et on analyse ta présence en ligne.' },
  { key: 'communication_tone', icon: '✍️', label: 'Ton de communication', why: 'L\'IA écrit tes messages comme TOI tu parles à tes clients — pas comme un robot.' },
  { key: 'business_phone',     icon: '📞', label: 'Téléphone pro',     why: 'Tes clients peuvent te rappeler en 1 clic depuis tes e-mails et SMS.' },
  { key: 'city',               icon: '📍', label: 'Ville',             why: 'Tes messages sont signés proprement, avec une vraie adresse locale en pied de mail.' },
];

// Lien direct vers le bon champ des Réglages.
export const essentialLink = (key) => `/settings?tab=entreprise&focus=${key}`;

// Les champs encore vides, dans l'ordre.
export function missingEssentials(companyProfile) {
  const cp = companyProfile || {};
  return PROFILE_ESSENTIALS.filter(f => {
    const v = cp[f.key];
    return v === undefined || v === null || String(v).trim() === '';
  });
}
